import { render, staticRenderFns } from "./component_detail_base_history.vue?vue&type=template&id=3f8ce9ca"
import script from "./component_detail_base_history.vue?vue&type=script&lang=js"
export * from "./component_detail_base_history.vue?vue&type=script&lang=js"
import style0 from "./component_detail_base_history.vue?vue&type=style&index=0&id=3f8ce9ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports